import { Enum } from './enum.class.js';
import EnumItem from './enumItem.class.js';

/**
 * Enum para tipos de prazo de entrega
 * Equivalente ao enum Java TipoPrazoDeEntrega
 */
class TipoPrazoDeEntregaEnum extends Enum {
    constructor() {
        super();
        this.DIA_FIXO = new EnumItem(1, 'DIA_FIXO');
        this.DIA_FIXO.descricao = 'Dia fixo';
        
        this.DIA_UTIL = new EnumItem(2, 'DIA_UTIL');
        this.DIA_UTIL.descricao = 'Dia útil';
    }
}

export const tipoPrazoDeEntregaEnum = new TipoPrazoDeEntregaEnum();